/**
 * Which page a message to the assistant is sent from, so "this client"
 * resolves to the record on screen. Mirrors the backend's PAGE_RECORD_TYPES
 * (apps/panel-api/src/agent/context/page-context.ts). The server re-reads the
 * record inside the tenant, so this is a hint, never an authority.
 */

export type PageRecordType = 'client' | 'subscription' | 'module' | 'bundle';

export interface PageContext {
  route: string;
  recordType?: PageRecordType;
  recordId?: string;
}

const OBJECT_ID = '([a-f0-9]{24})';

/** First match wins. Catalog pages may use a slug: those report the route only. */
const RECORD_ROUTES: Array<[RegExp, PageRecordType]> = [
  [new RegExp(`^/clients/${OBJECT_ID}(?:/|$)`), 'client'],
  [new RegExp(`^/subscriptions/${OBJECT_ID}(?:/|$)`), 'subscription'],
  [new RegExp(`^/catalog/modules/${OBJECT_ID}(?:/|$)`), 'module'],
  [new RegExp(`^/catalog/bundles/${OBJECT_ID}(?:/|$)`), 'bundle'],
];

/** Same shape the backend accepts; anything else is not sent at all. */
const ROUTE_PATTERN = /^\/[A-Za-z0-9\-_/]{0,199}$/;

export function pageContextFor(pathname: string): PageContext | undefined {
  if (!ROUTE_PATTERN.test(pathname)) return undefined;
  for (const [pattern, recordType] of RECORD_ROUTES) {
    const match = pattern.exec(pathname);
    if (match) return { route: pathname, recordType, recordId: match[1] };
  }
  return { route: pathname };
}
